var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#10539E",
    d: "m8.742 4.238-.005.006L2.8 10.365a1 1 0 0 0-.125.16l-.093.176-.039.12v.089a1.2 1.2 0 0 0 0 .408v.177l.07.136q.06.115.148.208l5.976 6.145a.994.994 0 0 0 1.443 0 1.1 1.1 0 0 0 0-1.482L6.641 12.84a.41.41 0 0 1 .006-.567.38.38 0 0 1 .266-.114h11.556c.561 0 1.017-.47 1.017-1.05s-.455-1.05-1.017-1.05H6.913a.395.395 0 0 1-.383-.406.4.4 0 0 1 .111-.274l3.54-3.646a1.1 1.1 0 0 0 0-1.49.994.994 0 0 0-1.439-.006"
  })));
};
export default SvgArrowBack;